import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment'


@Injectable()
export class ResetpasswordService {

  constructor(private http: HttpClient, private handler: HttpBackend) { }

    /*loginUser
    setUsername(data){
        this.loginUser = data
    }*/

  postLoginData(data){
    console.log(data)
    const params = data;
    return this.http.post(environment.restAPI + 'login',
    params, {}).pipe(map((res: any) => res));

  }
  postForgotPasswordData(data){
    const params = {userName : ''};
    params.userName = data;
    return this.http.post(environment.restAPI + 'sendEmail/',
    params, {}).pipe(map((res: any) => res));
  }
  changePassword(data, pwd){
    const  params = {password: ''};
    params.password = pwd;
    return this.http.put(environment.restAPI + 'password/request/' + data,
    params, {
    }).pipe(map((res: any) => res));
  }
  displayUserName(data){
      return data.name;
  }
  validateToken(data){
   // alert("validate token")
    this.http = new HttpClient(this.handler);
    return this.http.get(environment.restAPI + 'password/request/validate/' + data,
     {}).pipe(map((res: any) => res));
  }
}
